<template>
  <modal name="report-modal"
         @closed="$emit('updateComparisonData')"
         @before-open="beforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Հաշվետվություն</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('report-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <vue-html2pdf
          :show-layout="true"
          :float-layout="false"
          :enable-download="false"
          v-show="true"
          @beforeDownload="beforeDownload($event)"
          :paginate-elements-by-height="900"
          filename="Պայմանագրի նախագիծ"
          :pdf-quality="2"
          pdf-content-width="auto"
          :html-to-pdf-options="{
              margin: [5, 5, 0, 5],
              filename: 'Պայմանագրի նախագիծ',
              jsPDF: { format: 'a4', orientation: 'portrait' },
              html2canvas: {
                  scrollX: 0,
                  scrollY: 0
              }
          }"
          ref="html2Pdf"
      >
          <section slot="pdf-content" contenteditable="true" class="px-2">
                <p style="text-align: center;"><b>ՀԱՇՎԵՏՎՈՒԹՅՈՒՆ</b></p>
                <p style="text-align: center;">iTender համակարգում տեղադրված մրցույթի մասին</p>
                <br/>
                <table 
                    style="width: 100%;
                    table-layout: fixed;
                    border-collapse: collapse;
                    page-break-inside: avoid;
                    border: 1px solid  black;
                    text-align: center;"
                >
                    <tr>
                        <td
                            style="border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >
                            Կազմակերպիչի անվանումը
                        </td>
                        <td
                            style="border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >
                            {{customerName}}
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >
                            Մրցույթի անվանումը
                        </td>
                        <td
                            style="border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >
                            {{tender.title || '-'}}
                        </td>
                    </tr>
                    <tr>
                        <td
                         style="border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >Մրցույթի ծածկագիրը</td>
                        <td
                         style="border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >{{tender.password || '-'}}</td>
                    </tr>
                    <tr>
                        <td
                         style="border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >Հրապարակման ամսաթիվը</td>
                        <td
                         style=" border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >{{tender.opening_date}}</td>
                    </tr>
                    <tr>
                        <td
                         style=" border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >Վերջնաժամկետի ամսաթիվը</td>
                        <td
                         style=" border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >{{tender.finish_date}}</td>
                    </tr>
                    <tr>
                        <td
                         style=" border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >Մարզը</td>
                        <td
                         style=" border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >{{tender.region}}</td>
                    </tr>
                    <tr>
                        <td
                         style=" border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >Տեսակը</td>
                        <td
                         style=" border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >{{tender.type === "PAPER" ? 'Թղթային' : 'Էլեկտրոնային'}}</td>
                    </tr>
                    <tr>
                        <td
                         style=" border: 1px solid  black;
                                                        border-collapse: collapse;"
                        >Նախահաշվային գինը</td>
                        <td
                         style=" border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >{{tender.price || '-'}}</td>
                    </tr>
                    <tr>
                        <td
                         style=" border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >Երաշխիքով</td>
                        <td
                         style=" border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >{{tender.guaranteed ? 'Այո' : 'Ոչ'}}</td>
                    </tr>
                    <tr>
                        <td
                         style=" border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >Ծանուցում ստացած հնարավոր մասնակիցների քանակը</td>
                        <td
                         style=" border: 1px solid  black; border-collapse: collapse;padding:10px"
                        >{{tender.participants_count}}</td>
                    </tr>
                </table>

          </section>
      </vue-html2pdf>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button @click="$modal.hide('report-modal')" class="btn btn-sm btn-light mr-3">
        Փակել
      </button>
      <button  :disabled="isLoading" @click="download" type="button" class="btn btn-sm btn-primary">
        <span v-if="isLoading" class="mr-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span class="mr-2">Բեռնել</span>
        <font-awesome-icon :icon="['fas', 'download']"/>
      </button>
    </div>
  </modal>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'ReportModal',
      components: {
        VueHtml2pdf,
    },
  data () {
    return {
      organize: {},
      tender: '',
      isLoading: false,
      customerName: '',
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    download() {
      this.sendToPDFGeneration(this, this.$refs.html2Pdf.$el.innerHTML, 'Պայմանագիր', () => {this.isLoading = false})
    },
    consoleLog(data){
      console.log(data)
    },
    beforeOpen({params}) {
        console.log(params)
        console.log(this.me)
        this.tender = params
        const organisation = this.me.organisation[0];
        console.log(organisation)
        if(organisation.id_card_number){
            this.customerName = organisation.translations.name.hy
        } else {
            this.customerName = `«${organisation.translations.name.hy}» ${organisation.translations.company_type.hy}`
        }
        console.log(this.customerName) 
    },
  }
}
</script>

<style scoped>
/deep/ .vm--modal {
    top: 1rem !important;
    left: unset !important;
    width: 960px !important;
    height: 95% !important;
    margin: auto;
    -webkit-border-radius: 0.3rem !important;
    -moz-border-radius: 0.3rem !important;
    border-radius: 0.3rem !important;
}
</style>

